<section class="dashboard">
  <div class="page-heading">
    <div>
      <p>Overview</p>
      <h2>{{ isBusinessPortal ? 'Business dashboard' : 'Dashboard' }}</h2>
    </div>
    @if (!isBusinessPortal) {
      <button type="button" (click)="openBusinesses()">
        <span class="material-symbols-outlined" aria-hidden="true">add_business</span>
        Add business
      </button>
    }
  </div>

  @if (isLoading()) {
    <p class="state">Loading dashboard...</p>
  }

  @if (errorMessage()) {
    <p class="state error">{{ errorMessage() }}</p>
  }

  @if (isBusinessPortal) {
    <section class="sales-overview">
      <div class="section-heading">
        <div>
          <p>Sales performance</p>
          <h3>Revenue overview</h3>
        </div>
        @if (sales()) { <span>{{ sales()!.period }}</span> }
      </div>

      @if (salesLoading()) {
        <div class="sales-skeleton" aria-label="Loading sales overview">
          @for (item of [1, 2, 3, 4]; track item) { <span></span> }
        </div>
      } @else if (salesError()) {
        <p class="state error">{{ salesError() }}</p>
      } @else if (sales(); as summary) {
        <div class="sales-cards">
          <article class="metric revenue">
            <div class="metric-icon"><span class="material-symbols-outlined">payments</span></div>
            <div><span>Total revenue</span><strong>{{ summary.totalRevenue | currency:'INR':'symbol':'1.0-0' }}</strong><small>{{ summary.totalOrders }} orders · {{ summary.unitsSold }} units</small></div>
          </article>
          <article class="metric online">
            <div class="metric-icon"><span class="material-symbols-outlined">language</span></div>
            <div><span>Online sales</span><strong>{{ summary.onlineRevenue | currency:'INR':'symbol':'1.0-0' }}</strong><small>{{ summary.onlineSales }} orders</small></div>
          </article>
          <article class="metric store">
            <div class="metric-icon"><span class="material-symbols-outlined">storefront</span></div>
            <div><span>Store sales</span><strong>{{ summary.storeRevenue | currency:'INR':'symbol':'1.0-0' }}</strong><small>{{ summary.storeSales }} orders</small></div>
          </article>
          <article class="metric profit">
            <div class="metric-icon"><span class="material-symbols-outlined">trending_up</span></div>
            <div><span>Gross profit</span><strong>{{ summary.grossProfit | currency:'INR':'symbol':'1.0-0' }}</strong><small>Cost {{ summary.costOfGoods | currency:'INR':'symbol':'1.0-0' }}</small></div>
          </article>
        </div>

        <div class="business-insights">
          <section class="panel inventory-panel">
            <div class="panel-title"><h3>Inventory snapshot</h3><span>Live</span></div>
            <div class="inventory-values">
              <div><span>Stock value</span><strong>{{ summary.inventoryValue | currency:'INR':'symbol':'1.0-0' }}</strong></div>
              <div><span>Available units</span><strong>{{ summary.inventoryUnits }}</strong></div>
              <div><span>Ready to sell</span><strong>{{ summary.readyToSellUnits }}</strong></div>
            </div>
          </section>
          <section class="panel recent-sales">
            <div class="panel-title"><h3>Recent sales</h3><span>{{ summary.recentSales.length }}</span></div>
            @if (summary.recentSales.length) {
              <div class="sale-list">
                @for (sale of summary.recentSales; track sale.id) {
                  <div>
                    <span class="sale-channel" [class.online]="sale.saleChannel === 'Online'"><i class="material-symbols-outlined">{{ sale.saleChannel === 'Online' ? 'language' : 'storefront' }}</i>{{ sale.saleChannel }}</span>
                    <span class="sale-title">{{ sale.productTitle }}</span>
                    <small>{{ sale.createdAt | date:'dd MMM, h:mm a' }}</small>
                    <strong>{{ sale.totalAmount | currency:'INR':'symbol':'1.0-0' }}</strong>
                  </div>
                }
              </div>
            } @else { <p class="empty-sales">No sales recorded this month.</p> }
          </section>
        </div>
      }
    </section>
  }

  <div class="stats">
    @for (stat of stats(); track stat.label) {
      <article [class.subscription-stat]="stat.label === 'Subscription'" [class.internal-plan]="stat.label === 'Subscription' && stat.value === 'ZepBazaar Internal'">
        <span>@if (stat.label === 'Subscription') { <i class="material-symbols-outlined">{{ stat.value === 'ZepBazaar Internal' ? 'shield_lock' : 'workspace_premium' }}</i> }{{ stat.label }}</span>
        <strong>{{ stat.value }}</strong>
        <small>{{ stat.detail }}</small>
        @if (isBusinessPortal && stat.label === 'Subscription') { @if (stat.value === 'ZepBazaar Internal') { <em><span class="material-symbols-outlined">verified</span>Protected platform plan</em> } @else { <button class="plan-action" type="button" (click)="openPlans()">Change plan <span class="material-symbols-outlined">arrow_forward</span></button> } }
      </article>
    }
  </div>

  <div class="dashboard-grid">
    <section class="panel">
      <div class="panel-title">
        <h3>{{ isBusinessPortal ? 'Workspace status' : 'Access health' }}</h3>
        <span>Live</span>
      </div>
      <div class="health-list">
        <div>
          <span>{{ isBusinessPortal ? 'Business approval' : 'Admin coverage' }}</span>
          <strong>{{ isBusinessPortal ? 'Verified' : '100%' }}</strong>
        </div>
        <div>
          <span>{{ isBusinessPortal ? 'Subscription' : 'Users with MFA' }}</span>
          <strong>{{ isBusinessPortal ? 'Active' : '84%' }}</strong>
        </div>
        <div>
          <span>{{ isBusinessPortal ? 'Portal access' : 'Pending invites' }}</span>
          <strong>{{ isBusinessPortal ? 'Enabled' : '5' }}</strong>
        </div>
      </div>
    </section>

    <section class="panel">
      <div class="panel-title">
        <h3>Recent activity</h3>
        <span>Today</span>
      </div>
      <ul>
        @for (item of activity(); track item) {
          <li>{{ item }}</li>
        }
      </ul>
    </section>
  </div>
</section>
